// extracted by mini-css-extract-plugin
export default {"plansBlock":"view-plans_plansBlock_IrY22"};